/* unplugin-vue-components disabled */import script from "./xToolbarLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./xToolbarLayout.vue?vue&type=script&setup=true&lang=js"

import "./xToolbarLayout.vue?vue&type=style&index=0&id=0b2b626b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2b626b"]])

export default __exports__